import React, { useEffect, useState } from "react";
import { getCorpHistories } from "../../utils/cms.utils";
import {MONTHS} from "../../utils/constant/month.constant";
const sortHistoriesAsc = (items = []) => {
    return [...items].sort((a, b) => {
        // year (wajib ada)
        if (a.year !== b.year) {
            return Number(a.year) - Number(b.year);
        }

        // month (opsional)
        if (a.month !== b.month) {
            if (a.month == null) return -1;
            if (b.month == null) return 1;
            return a.month - b.month;
        }

        // day (opsional)
        if (a.day !== b.day) {
            if (a.day == null) return -1;
            if (b.day == null) return 1;
            return a.day - b.day;
        }

        return 0;
    });
};
const formatHistoryDate = ({ year, month, day }) => {
    const parts = [];

    if (day) {
        parts.push(day);
    }

    if (month) {
        parts.push(month);
    }

    if (year) {
        parts.push(year);
    }

    return parts.join(" ");
};


const CompanyHistory = () => {
    const [corpHistory, setCorpHistory] = useState([]);

    useEffect(() => {
        const data = getCorpHistories();
        const items = Array.isArray(data) ? data : [];

        setCorpHistory(sortHistoriesAsc(items));
    }, []);

    if (!corpHistory.length) return null;

    return (
        <div className="history__area section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="company__history-area">
                            {corpHistory.map((item, index) => (
                                <div
                                    className="company__history-area-item"
                                    key={index}
                                >
                                    <div className="company__history-area-item-date text-center">
                                        <span>
                                            {formatHistoryDate(item)}
                                        </span>
                                    </div>

                                    <div className="company__history-area-item-inner">
                                        <div className="company__history-area-item-inner-content">
                                            <h4 className="mb-4">
                                                {item.title}
                                            </h4>

                                            <p
                                                dangerouslySetInnerHTML={{
                                                    __html: item.descriptionEn,
                                                }}
                                            />

                                            <p
                                                className="history-note"
                                                dangerouslySetInnerHTML={{
                                                    __html: item.descriptionId,
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CompanyHistory;
